<div tabindex="-1" aria-hidden="true" #modalTemplate [class]="modalClass()">
  @if (fullscreenConfig()) {
    <div
      class="absolute top-24 h-[calc(100%-24px)] w-full overflow-hidden rounded-tl-12 rounded-tr-12 border-0.7 shadow-fullscreen-modal [border-image:linear-gradient(360deg,#B3B3B617.66%,#FFFFFF69.84%)]"
    >
      <!-- Modal content -->
      <div class="relative flex h-full w-full flex-col gap-40 bg-secondary-greys-white pb-40">
        <!-- Modal header -->
        <div class="flex flex-row-reverse border-b py-24 pl-[60px] pr-24">
          <app-tooltip body="Close Window">
            <app-button-secondary
              [ghost]="true"
              icon="images/Cancel_24px.svg"
              (buttonClicked)="closeModal.open()"
            ></app-button-secondary>
          </app-tooltip>
        </div>
        <!-- Modal body -->
        <div class="grow overflow-hidden">
          <ng-container *ngTemplateOutlet="fullscreenConfig()!.template"></ng-container>
        </div>
      </div>
    </div>
  } @else if (dialogConfig()) {
    <div class="absolute top-1/2 mx-40 block max-w-[440px] -translate-y-1/2 sm:hidden">
      <div
        class="relative flex w-full flex-col items-start justify-between gap-y-40 rounded-t-12 border-x-0.5 border-t-0.5 border-secondary-greys-50 bg-secondary-greys-white shadow-dialog-mogal"
      >
        <div
          class="absolute left-1/2 top-[-16px] -translate-x-1/2 rounded-2 border-3 border-secondary-greys-white p-4"
          [ngClass]="{
            'bg-secondary-crimson-50': dialogConfig()!.variant === 'negative',
            'bg-brand-50': dialogConfig()!.variant === 'info'
          }"
        >
          <svg-icon [src]="dialogConfig()!.icon"></svg-icon>
        </div>
        <div class="flex h-56 w-full items-center justify-end border-b-0.7 border-secondary-greys-50 px-16">
          @if (dialogConfig()!.closeButton) {
            <div class="w-fit">
              <app-tooltip body="Close">
                <app-button-secondary
                  [ghost]="true"
                  icon="images/Cancel_24px.svg"
                  (buttonClicked)="onCloseDialog()"
                ></app-button-secondary>
              </app-tooltip>
            </div>
          }
        </div>
        <div class="flex flex-col items-center justify-center gap-16 px-24">
          <div class="text-center text-display-xs-500 text-secondary-greys-black">
            {{ dialogConfig()!.title }}
          </div>
          <div class="text-center text-body-md-400 text-secondary-greys-900">
            {{ dialogConfig()!.description }}
          </div>
        </div>
        <div class="flex w-full flex-wrap justify-around gap-12 px-16 pb-16 pt-8">
          <app-button-secondary
            class="grow"
            [label]="dialogConfig()!.buttonCancelLabel"
            (buttonClicked)="onCancelDialog()"
          ></app-button-secondary>
          <app-button-primary
            class="grow"
            [type]="dialogConfig()!.variant === 'negative' ? 'negative' : 'default'"
            [label]="dialogConfig()!.buttonConfirmLabel"
            (buttonClicked)="onConfirmDialog()"
          ></app-button-primary>
        </div>
      </div>
    </div>

    <!-- Desktop version -->
    <div class="absolute top-[200px] hidden sm:block">
      <div
        class="relative flex h-[300px] w-[440px] flex-col items-start justify-between rounded-tl-12 rounded-tr-12 border-0.5 border-secondary-greys-50 bg-secondary-greys-white shadow-dialog-mogal"
      >
        <div
          class="absolute left-[196px] top-[-16px] rounded-2 border-3 border-secondary-greys-white p-4"
          [ngClass]="{
            'bg-secondary-crimson-50': dialogConfig()!.variant === 'negative',
            'bg-brand-50': dialogConfig()!.variant === 'info'
          }"
        >
          <svg-icon [src]="dialogConfig()!.icon"></svg-icon>
        </div>
        <div class="flex h-56 w-full items-center justify-end border-b-0.7 border-secondary-greys-50 px-24">
          @if (dialogConfig()!.closeButton) {
            <div class="w-fit">
              <app-tooltip body="Close">
                <app-button-secondary
                  [ghost]="true"
                  icon="images/Cancel_24px.svg"
                  (buttonClicked)="onCloseDialog()"
                ></app-button-secondary>
              </app-tooltip>
            </div>
          }
        </div>
        <div class="flex flex-col items-center justify-center gap-16 px-24">
          <div class="text-center text-display-xs-500 text-secondary-greys-black">
            {{ dialogConfig()!.title }}
          </div>
          <div class="text-center text-body-md-400 text-secondary-greys-900">
            {{ dialogConfig()!.description }}
          </div>
        </div>
        <div class="flex w-full items-center gap-16 px-24 pb-24">
          <app-button-secondary
            class="grow"
            [label]="dialogConfig()!.buttonCancelLabel"
            (buttonClicked)="onCancelDialog()"
          ></app-button-secondary>
          <app-button-primary
            class="grow"
            [type]="dialogConfig()!.variant === 'negative' ? 'negative' : 'default'"
            [label]="dialogConfig()!.buttonConfirmLabel"
            (buttonClicked)="onConfirmDialog()"
          ></app-button-primary>
        </div>
      </div>
    </div>
  }
</div>

<app-modal-dialog
  #closeModal
  type="negative"
  icon="images/Warning_48px.svg"
  buttonCancelLabel="Cancel"
  buttonConfirmLabel="Yes, Close"
  description="If you close the form, all the project details will not be saved."
  title="Are you sure you want to close the form?"
  (confirmClicked)="onCloseFullscreen()"
></app-modal-dialog>
